import { HTTP_STATUS_CODE } from "../../constants/apiResponseCode.constants";
import { API_RESPONSE_CODE } from "../../constants/apiResponseCode.constants";

const FULL_SCREEN_ERROR_STRINGS = (t) => ({
  [HTTP_STATUS_CODE.UNAUTHORIZED]: {
    title: t("errorScreens.unauthorizedTitle"),
    message: t("errorScreens.unauthorizedMessage"),
    buttonText: t("errorScreens.loginAgain"),
  },
  [HTTP_STATUS_CODE.SERVICE_UNAVAILABLE]: {
    title: t("errorScreens.maintenanceTitle"),
    message: t("errorScreens.maintenanceMessage"),
    buttonText: t("errorScreens.contactUs"),
  },
  [API_RESPONSE_CODE.APP_CRASH]: {
    title: t("errorScreens.unexpectedErrorTitle"),
    message: t("errorScreens.unexpectedErrorMessage"),
    buttonText: t("errorScreens.contactUs"),
  },
});

export default FULL_SCREEN_ERROR_STRINGS;
